import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import { isAfter } from 'date-fns';
import { FC, useMemo, useState } from 'react';
import { formatDate } from '../../../utils/dateUtils';

interface ConfirmDialogProps {
  title: string;
  message: string;
  dateInit?: Date;
  enableDateInput?: boolean;
  requireFutureDate?: boolean;
  onValidate: (date: Date) => void;
  onCancel: () => void;
}

export const ConfirmDialog: FC<ConfirmDialogProps> = ({
  title,
  message,
  dateInit,
  enableDateInput,
  requireFutureDate,
  onValidate,
  onCancel,
}) => {
  const [internalDate, setInternalDate] = useState(
    () =>
      formatDate(dateInit || new Date(), "yyyy-MM-dd'T'HH:mm") ??
      formatDate(new Date(), "yyyy-MM-dd'T'HH:mm") ??
      '',
  );

  const isDateInFuture = useMemo(
    () => isAfter(new Date(internalDate), new Date()),
    [internalDate],
  );

  const isValidateDisabled = requireFutureDate && !isDateInFuture;

  return (
    <>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
          {/* eslint-disable-next-line react/no-danger */}
          <p dangerouslySetInnerHTML={{ __html: message }} />
          {enableDateInput && (
            <TextField
              id="datetime-local"
              inputProps={{
                min: requireFutureDate
                  ? formatDate(new Date(), "yyyy-MM-dd'T'HH:mm")
                  : '1970-01-01T00:00',
                max: '2100-01-01T00:00',
              }}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={({ target }) => {
                setInternalDate(target.value);
              }}
              type="datetime-local"
              value={internalDate}
              variant="standard"
              sx={{ ml: 1 }}
            />
          )}
        </Box>
        {requireFutureDate && (
          <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
            La date de programmation doit être ultérieure à maintenant.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => onCancel()}>
          Annuler
        </Button>
        <Button
          variant="contained"
          disabled={isValidateDisabled}
          onClick={() =>
            onValidate(internalDate ? new Date(internalDate) : new Date())
          }
        >
          Valider
        </Button>
      </DialogActions>
    </>
  );
};
